<template>
<section class="container">
  <section class="panel center-block">
    <div class="container-fluid">

      <h1 class="sep mt-3">Vous avez déjà répondu à la question of the day!</h1>
      <div class="text-center card bg-primary">
        <p><i class="icon thumb-up-white"></i> </p>
        <p class="hauracherell text-white">Rendez-vous demain pour la prochaine question.</p>
      </div>
      <h2 style="display:none" class="hauracherell text-center text-primary mt-5" v-if="$parent.IsParticipant()===true">
        Vous êtes <span class="text-warning">{{Reponse.Stats.Ordre}}</span> de notre classement avec <span class="text-warning">{{Reponse.Stats.NombrePoints}} point(s).<br /></span>
        Rendez-vous demain pour la question suivante .
      </h2>

      <h3 class="hauracherell">Voici les statistiques du challenge en cours</h3>
      <div class="group__circle">

        <div class="circle bg-primary">
          <p>{{Reponse.Stats.TauxParticipation}} %</p>
          <p>de<br>participation</p>
        </div>
        <div class="circle bg-warning">
          <p>{{Reponse.Stats.TauxBonnesReponses}} %</p>
          <p>de bonnes<br>réponses</p>
        </div>
        <div class="circle bg-warning">
          <p>{{Reponse.Stats.MoyenTempReponse}} s</p>
          <p>de temps<br>de réponse</p>
        </div>

      </div><!-- D FLEX-->
      <div class="ranking ranking--primary" v-show="StatsLoaded">
        <ul>
          <li class="second"><span>2</span><strong v-html="GetParticipantOrder(2)"></strong></li>
          <li class="first"><span>1</span><strong v-html="GetParticipantOrder(1)"></strong></li>
          <li class="tertiary"><span>3</span><strong v-html="GetParticipantOrder(3)"></strong></li>
        </ul>
        <h3 class="hauracherell">Classement des collaborateurs</h3>
        <!-- <div class="panel-bottom"></div> -->
      </div><!--RANKING-->
      <div class="ranking ranking--warning" v-show="StatsLoaded">
        <ul>
          <li class="second"><span>2</span><strong v-html="GetGroupeOrder(2)"></strong></li>
          <li class="first"><span>1</span><strong v-html="GetGroupeOrder(1)"></strong></li>
          <li class="tertiary"><span>3</span><strong v-html="GetGroupeOrder(3)"></strong></li>
        </ul>
        <h3 class="hauracherell">Classement des {{Reponse.IntituleGroupe}}</h3>
        <!-- <div class="panel-bottom"></div> -->
      </div><!--RANKING-->
    </div>
  </section><!-- PANEL -->
  <span class="panel-bottom"></span>
  
</section><!-- CONTAINER FLUID-->
</template>
<script>
    import $ from 'jquery';
    import { Utility } from '../configs/configpaths';
    export default {
        data: function () {

            return {

                modalOpen_required: false,
                Reponse: {
                    ReponseCorrecte: false, Reponses: [], Stats: {}
              },
              STATS: null,
              StatsLoaded: false,
              Loaded: false
            };
        },

        mounted: function () {
            
          var _self = this;
          _self.$parent.GloablEvents();
          
        
            var CURRENT_USER = Utility.GetCurrent();
            var TOKEN = Utility.GetToken();
            if (CURRENT_USER ==="") {
               
                _self.$router.push('/');
            }
            var settings = {
                "crossDomain": true,
                "url": _self.BASE_URL + "api/question/Result",
                "data": {
                    "questionId": parseInt(_self.$route.params.id),
                    "participant": parseInt(CURRENT_USER.Id),
                    "challenge": parseInt(CURRENT_USER.Challenge),
                    "isTesteur": CURRENT_USER.Role === "TESTEUR"
                },
                "method": "GET",
                "headers": {
                    'Authorization': 'Bearer ' + TOKEN
                }
            };

            $.ajax(settings).done(function (response) {


              _self.Reponse = response;
              _self.GetStats();
              
            }).fail(function () {
                _self.$router.push('/');

            });
        },
        methods: {

          GetStats: function () {
            var _self = this;

            var CURRENT_USER = Utility.GetCurrent();
            var TOKEN = Utility.GetToken();
            if (!CURRENT_USER) {

              _self.$router.push('/');
            }
            var settings = {
              "async": false,
              "crossDomain": true,
              "url": _self.BASE_URL + "api/Question/Stats",
              "data": {
                "id": CURRENT_USER.Id,
              },
              "method": "GET",
              "headers": {
                'Authorization': 'Bearer ' + TOKEN
              }
            };

            $.ajax(settings).done(function (response) {


              _self.STATS = response;
              _self.StatsLoaded = true;
            }).fail(function () {


            });
          },
          GetParticipantOrder: function (index) {
            var CURRENT_USER = Utility.GetCurrent();
            if (CURRENT_USER.Role === "TESTEUR")
              return "";
            if (this.STATS != null) {

              try {
                return this.STATS.ClassementParicipants[index - 1].Nom + "<br/>" + this.STATS.ClassementParicipants[index - 1].NombrePoints +" points";
              } catch (e) {
                return "";
              }
            }

          },
          GetGroupeOrder: function (index) {
            var CURRENT_USER = Utility.GetCurrent();
            if (CURRENT_USER.Role === "TESTEUR")
              return "";

            if (this.STATS != null) {

              try {
                return this.STATS.ClassementMagasins[index - 1].Magasin + "<br/>" + this.STATS.ClassementMagasins[index - 1].NombrePoints + " points";
              } catch (e) {
                return "";
              }
            }
          }
        }
    }
</script>
<style lang="scss" scoped>
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
